import React, { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";
import usePermissions from "hooks/usePermissions";
import LocationFilter from "components/molecules/LocationFilter/LocationFilter";
import testIds from "constants/testIds";
import Button from "components/atoms/Button/Button";
import CardNew from "components/molecules/Card/CardNew";
import AnalyticsProvider from "./components/AnalyticsProvider";
import DateFilter from "./components/DateFilter";
import AnalyticNav from "./components/AnalyticsNav";
import Reports from "./components/Reports";
import Billing from "./components/Billing/Billing";
import Location from "./components/Location/Location";
import FreightModes from "./components/FreightModes/FreightModes";
import Providers from "./components/Providers/Providers";
import AnalyticsContext from "./components/analyticsContext";
import NewReport from "../../common/Analytics/components/Reports/NewReport";
import "./Analytics.scss";

const Analytics = function () {
  const { permissions } = usePermissions();
  const navigate = useNavigate();

  const searchParams = new URLSearchParams(window.location.search);
  const filter = searchParams.get("filter");

  useEffect(() => {
    if (!JSON.parse(permissions).permissions.reporting.view_analytics) navigate("/access-denied");
  }, []);

  return (
    <AnalyticsProvider>
      <CardNew borderRadius={filter === "reports" ? "16px" : "16px 16px 0px 0px"}>
        <h3 className="font-weight-bold mb-3 pb-2 d-none d-md-block">
          {filter === "new report" ? (
            <FormattedMessage id="report.newReport" defaultMessage="New Report" />
          ) : (
            <FormattedMessage id="general.analytics" defaultMessage="Analytics" />
          )}
        </h3>
        <div
          className="pb-3 ml-0 d-flex justify-content-between align-items-center 
           analytics-nav flex-wrap"
        >
          {filter !== "new report" && <AnalyticNav />}

          {filter !== "new report" && filter !== "reports" && (
            <div>
              <div className="d-flex align-items-center flex-wrap" style={{ marginRight: "15px" }}>
                <span className="d-flex align-items-center flex-wrap">
                  <div className="mb-xs-2">
                    <AnalyticsContext.Consumer>
                      {(val) => <LocationFilter onChange={val.setPaymentLocation} />}
                    </AnalyticsContext.Consumer>
                  </div>
                  <span className="ml-sm-3 mb-xs-2">
                    <DateFilter />
                  </span>
                </span>
                <Button
                  to="/analytics?filter=new report"
                  className="rounded-pill ml-sm-3"
                  id="New-report"
                  style={{ height: "26px" }}
                  data-testid={testIds.ANALYTICS_CREATE_REPORT_BUTTON}
                  onClick={() => {
                    navigate("/analytics?filter=new report");
                  }}
                >
                  <FormattedMessage id="report.newReport" defaultMessage="New Report" />
                </Button>
              </div>
            </div>
          )}
        </div>
      </CardNew>
      {filter === "reports" ? (
        <Reports />
      ) : (
        filter === "new report" && (
          <NewReport
            onSuccess={() => navigate("/analytics?filter=reports")}
            onCancel={() => navigate("/analytics?filter=reports")}
          />
        )
      )}
      {filter === "location" && <Location />}
      {filter === "providers" && <Providers />}
      {filter === "freight modes" && <FreightModes />}
      {filter === "billing" && <Billing />}
    </AnalyticsProvider>
  );
};

export default Analytics;
